import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as home from "../components/home";
import MainHome from "../components/carousel/MainHome";
import { Footer } from "../layout";
import { getBanners } from "../Services/MainServices";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();
  const [banners, setBanners] = useState();
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    getBanner();
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/home");
    }
  }, [isAuthenticated]);

  const getBanner = async () => {
    try {
      const response = await getBanners();
      if (response.status === 200 || response?.data?.status === "success") {
        setBanners(response?.data?.data ?? {});
      }
    } catch (error) {}
  };

  return (
    <div className="mt-3 md:mt-5 flex flex-col gap-5">
      <MainHome />
      <home.ShopCardsSection banners={banners?.banners} />
      <home.HeroBar />
      <home.LandingPopularProducts />
      <home.ProductBanner topBanners={banners?.top_banners} />
      {/* <home.GreatSavingsSection /> */}
      {/* <home.Shortlist /> */}
      <Footer />
    </div>
  );
};

export default LandingPage;
